<template>
  <section
    class="relative h-[300px] md:h-[400px] bg-cover bg-center flex items-center justify-center text-white"
    :style="{ backgroundImage: `url(${pexel})` }"
  >
    <!-- Overlay -->
    <div class="absolute inset-0 bg-dark-blue bg-opacity-70"></div>

    <!-- Statistics Grid -->
    <div class="relative z-10 grid grid-cols-2 md:grid-cols-4 gap-8 text-center px-4">
      <div
        v-for="(stat, index) in themeStore.theme.StaticBanner"
        :key="index"
        class="flex flex-col items-center justify-center"
      >
        <img :src="stat.image" alt="icon" class="h-12 mb-3" />
        <span class="text-4xl font-bold mb-1">{{ stat.count }}</span>
        <p class="text-lg">{{ stat.label }}</p>
      </div>
    </div>
  </section>
</template>

<script setup>
import pexel from '../../assets/pexel.jpg'
const themeStore = useThemeStore();
import { useThemeStore } from '../../stores/themeStore';


</script>

<style scoped>
/* Optional: make the overlay color consistent */
.bg-dark-blue {
  background-color: #0b1d4056; /* Dark navy or replace as needed */
}
</style>
